import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Fade, Paper } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FormattedMessage } from 'react-intl';
import { NET_SALES_VAT } from '../../../common/charts/chartDataConfig';
import DashboardChartWrapper from './../DashboardChartWrapper';
import { getDateRangeString } from '../../../../utils/dates-utils';
import { TranslationsContext } from '../../../../config/translations';
import { lastAvailable7DaysSales } from '../DashboardSalesPerDate';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import NoDataAvailable from '../../../common/charts/NoDataAvailable';

const styles = (() => ({}));

const LastDaysSales = ({ dashboardReports, machines, styles, classes }) => {
  const charts = { LastDaysSales: { ...NET_SALES_VAT, labelFields: ['Datum'], time: true } };
  
  if (!dashboardReports || !machines) {
    return <div className={`${styles.loading} ${classes.lastMonthLoading}`}><CircularProgress color="primary" /></div>;
  }
  
  if (dashboardReports?.SalesLastMonth === '') {
    return <NoDataAvailable />;
  }
  
  return (
    <TranslationsContext.Consumer>
      {({ languageState }) => (
        <>
          <Fade in={true}>
            {!dashboardReports.error &&

            <Paper className={styles.chartCard}>
              <div className={styles.contentTitle}>
                <h3>
                  <FormattedMessage
                    id="page.dashboard.last7days"
                    defaultMessage="Last 7 days"
                  />
                </h3>
                {getDateRangeString(lastAvailable7DaysSales(dashboardReports), languageState)}
              </div>
              <DashboardChartWrapper
                reports={lastAvailable7DaysSales(dashboardReports)}
                chart={charts.LastDaysSales}
                languageState={languageState}
                oneWeek
              />
            </Paper>}
          </Fade>
        </>
      )}
    </TranslationsContext.Consumer>);
};

const decorate = compose(
  withStyles(styles),
  connect(
    store => ({
      machines: store.user.machines,
      dashboardReports: store.report.dashboard,
    }),
  ),
);

LastDaysSales.propTypes = {
  dashboardReports: PropTypes.object,
  machines: PropTypes.array,
  styles: PropTypes.object,
  classes: PropTypes.object,
};

export default decorate(LastDaysSales);
